export default {
  Admin: "Admin",
  Student: "Student",
  Teacher: "Teacher",
  Counselor: "Counselor",
  Family: "Family",
  Principal: "Principal"
};
